<script lang="ts">
  import { EmptyLabelDefault } from '$provider/constants/global';
  import { getFileNameFromPath } from '$shared/helpers/utils';

  interface Props {
    filePath?: string;
    fileName?: string;
    onevent?: (payload: { type: 'report-download'; data: string }) => void;
  }

  let { filePath = '', fileName = '', onevent }: Props = $props();

  const onClickLink = (): void => {
    onevent?.({ type: 'report-download', data: filePath });
  };
</script>

{#if filePath}
  <a class="ama-file-link" href="/" onclick={(e) => { e.preventDefault(); onClickLink(); }}
    >{fileName || getFileNameFromPath(filePath)}</a
  >
{:else}
  <div class="empty-value">{EmptyLabelDefault}</div>
{/if}

<style>
  .ama-file-link {
    color: var(--blue);
    text-decoration: none;
    cursor: pointer;
  }
</style>
